import type { ComponentProps } from "react"
import { forwardRef } from "react"

export const ImportantIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
	({ className, ...props }, ref) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			ref={ref}
			{...props}
			className={className}
		>
			<g transform="translate(12, 12) scale(0.9583) translate(-12, -12)">
				<path d="M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
			</g>
		</svg>
	),
)

export const ImportantIconOutline = forwardRef<
	SVGSVGElement,
	ComponentProps<"svg">
>(({ className, ...props }, ref) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		ref={ref}
		{...props}
		className={className}
	>
		<g transform="translate(12, 12) scale(0.9583) translate(-12, -12)">
			<path d="M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
		</g>
	</svg>
))
